import { useAuthTokenGetter } from "@memorang/ui/contexts/AuthTokenContext";
import { useCallback } from "react";
import { sendFeedback } from "../helpers";
import type { FeedbackParams } from "../types";

export const useSendFeedback = () => {
	const getAuthToken = useAuthTokenGetter();
	return useCallback(
		async (params: FeedbackParams, feedback: string) => {
			const token = await getAuthToken();
			return sendFeedback(params, feedback, token);
		},
		[getAuthToken],
	);
};
